import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    cardContentPadding: {
      padding: '24px;',
    },
    serviceTitle: {
      width: '100%',
      fontWeight: '700',
      fontSize: '13px',
      lineHeight: '15px',
    },
    serviceRange: {
      width: '100%',
      fontSize: '13px',
      lineHeight: '15px',
      display: 'flex',
      justifyContent: 'space-between',
      minHeight: '2rem',
      alignItems: 'center',
    },
    serviceRangeDate: {
      flexGrow: 1,
    },
    serviceRangeStatus: {
      flexGrow: 0,
    },
    listItem: {
      flexWrap: 'wrap',
      color: theme.palette.general.grey70,
      lineHeight: '3rem',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: '15px',
      paddingTop: 0,
    },
  };
});

const vehicleStatusStyles = makeStyles((theme) => {
  return {
    vehicleStatus: {
      fontSize: '12px',
      position: 'relative',
      '&::before': {
        content: "''",
        position: 'absolute',
        width: 5,
        height: 5,
        borderRadius: '50%',
        left: '-10px',
        bottom: '5px',
      },
    },
    active: {
      color: theme.palette.success.main,
      '&::before': {
        backgroundColor: theme.palette.success.main,
      },
    },
    inactive: {
      color: theme.palette.grey[500],
      '&::before': {
        backgroundColor: theme.palette.grey[500],
      },
    },
    blocked: {
      color: theme.palette.error.main,
      '&::before': {
        backgroundColor: theme.palette.error.main,
      },
    },
    unsharing: {
      color: theme.palette.warning.main,
      '&::before': {
        backgroundColor: theme.palette.warning.main,
      },
    },
  };
});

export { useStyles, customCardStyles, vehicleStatusStyles };
